module.exports = __webpack_public_path__ + "img/cybersafety.56186c48.png";